import { axios } from '@Root/API'

export const byFormat = (params, type) => {
  return axios.get(`export/${type}`, {
    params,
  })
}
